module.exports = __webpack_public_path__ + "static/fonts/feather.66cbb62.woff";


//////////////////
// WEBPACK FOOTER
// ./src/package/theme/fonts/feather.woff
// module id = Jnhk
// module chunks = 5